export class NovoComentario {
  comentario: string;
  tarefaId: number;
}
